module.exports = __webpack_public_path__ + "static/media/returnBack.89f3449f.svg";